/**
 *	app.conf.js
 */

var conf = function($urlRouterProvider, $locationProvider, $compileProvider) {

    $urlRouterProvider.otherwise("/");

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });

    $compileProvider.debugInfoEnabled(false);
};

conf.$inject = ['$urlRouterProvider', '$locationProvider', '$compileProvider'];

export default conf;
